import { render, staticRenderFns } from "./edit-code.vue?vue&type=template&id=2226d783&scoped=true"
import script from "./edit-code.vue?vue&type=script&lang=js"
export * from "./edit-code.vue?vue&type=script&lang=js"
import style0 from "./edit-code.vue?vue&type=style&index=0&id=2226d783&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226d783",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2226d783')) {
      api.createRecord('2226d783', component.options)
    } else {
      api.reload('2226d783', component.options)
    }
    module.hot.accept("./edit-code.vue?vue&type=template&id=2226d783&scoped=true", function () {
      api.rerender('2226d783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/edit-code.vue"
export default component.exports